import { Pipe, PipeTransform } from '@angular/core';
import { AccountModuleId, CMOrderModuleId, InvoiceOrderModuleId, JournalModuleId, LeadModuleId, SOModuleId } from '../constants/modules.constant';

@Pipe({
    name: 'importActionFilter'
})

export class ImportActionFilterPipe implements PipeTransform {
    transform(importActions: {name: string, value: string}[], moduleId: number): any[] {

        if ([JournalModuleId].includes(moduleId)) {
            return importActions.filter(a => a.value == 'add');
        }else if ([SOModuleId, CMOrderModuleId, InvoiceOrderModuleId, LeadModuleId, AccountModuleId].includes(moduleId)) {
            return importActions.filter(a => a.value !== 'addedit');
        }

        return importActions;
    }
}

